module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst attributes = model.data || {}\nlet start, end, timeRange = ''\nif(attributes.tripStart){\nstart = utils.moment(attributes.tripStart)\n}\nif(attributes.tripEnd){\nend = utils.moment(attributes.tripEnd)\n}\nif(start){\nif(end){\nif(start.format('DD.MM.YYYY') === end.format('DD.MM.YYYY')) {\ntimeRange = start.format('DD.MM.YYYY')\n} else if(start.format('YYYY') === end.format('YYYY')){\ntimeRange = `${start.format('DD.MM.')} - ${end.format('DD.MM.YYYY')}`\n} else {\ntimeRange = `${start.format('DD.MM.YYYY')} - ${end.format('DD.MM.YYYY')}`\n}\n} else {\ntimeRange = start.format('DD.MM.YYYY')\n}\n} else if(end){\ntimeRange = end.format('DD.MM.YYYY')\n} else {\ntimeRange = '-'\n}\nconst notInfo = attributes.notInfo || {}\nconst flags = {\n// info, ok, error\noffer:          attributes.offerSent           ? 'ok' : (notInfo.offer ? 'error' : 'info'),\nconfirmation:   attributes.confirmationSent    ? 'ok' : (notInfo.confirmation ? 'error' : 'info'),\ndriveOrder:     attributes.driveOrderIssued    ? 'ok' : (notInfo.driveOrder ? 'error' : 'info'),\ninvoice:        attributes.invoiceSent         ? 'ok' : (notInfo.invoice ? 'error' : 'info'),\n}\n%><div><%\nif(attributes.tripID){\n%><div class=\"group\"><%\n%><div class=\"head\"><%- storage.__('trips.schedulerSummary.title') %></div><%\n%><div class=\"value\"><%= attributes.title %></div><%\n%></div><%\n%><div class=\"group\"><%\n%><div class=\"head\"><%- storage.__('trips.schedulerSummary.internalNotices') %></div><%\n%><div class=\"value\"><%- String(attributes.internalNotices || '').replace(/\\n+/g, '<br>') %></div><%\n%></div><%\n%><div class=\"group\"><%\n%><div class=\"head\"><%- storage.__('trips.schedulerSummary.timeRange') %></div><%\n%><div class=\"value\"><%= timeRange %></div><%\n%></div><%\n%><div class=\"group\"><%\n%><div class=\"head\"><%- storage.__('trips.schedulerSummary.numberOfPersons') %></div><%\n%><div class=\"value\"><%= attributes.numberOfPersons %></div><%\n%></div><%\n%><div class=\"group\"><%\n%><div class=\"head\"><%- storage.__('trips.schedulerSummary.clientAddress') %></div><%\n%><div class=\"value\"><%- String(attributes.clientAddress || '').replace(/\\n+/g, '<br>') %></div><%\n%></div><%\n%><div class=\"group\"><%\n%><div class=\"head\"><%- storage.__('trips.schedulerSummary.status.head') %></div><%\n%><div class=\"value flags\"><%\nfor(const [flag, severity] of Object.entries(flags)){\n%><div class=\"flag\"><%\n%><div class=\"severity_<%- severity %>\"></div><%\n%><%= storage.__(`trips.schedulerSummary.status.${flag}`) %><%\n%></div><%\n}\n%></div><%\n%></div><%\n}\n%></div>"
  , __filename = "components/templates/office/scheduler/tripSummary.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const attributes = model.data || {}
let start, end, timeRange = ''
if(attributes.tripStart){
start = utils.moment(attributes.tripStart)
}
if(attributes.tripEnd){
end = utils.moment(attributes.tripEnd)
}
if(start){
if(end){
if(start.format('DD.MM.YYYY') === end.format('DD.MM.YYYY')) {
timeRange = start.format('DD.MM.YYYY')
} else if(start.format('YYYY') === end.format('YYYY')){
timeRange = `${start.format('DD.MM.')} - ${end.format('DD.MM.YYYY')}`
} else {
timeRange = `${start.format('DD.MM.YYYY')} - ${end.format('DD.MM.YYYY')}`
}
} else {
timeRange = start.format('DD.MM.YYYY')
}
} else if(end){
timeRange = end.format('DD.MM.YYYY')
} else {
timeRange = '-'
}
const notInfo = attributes.notInfo || {}
const flags = {
// info, ok, error
offer:          attributes.offerSent           ? 'ok' : (notInfo.offer ? 'error' : 'info'),
confirmation:   attributes.confirmationSent    ? 'ok' : (notInfo.confirmation ? 'error' : 'info'),
driveOrder:     attributes.driveOrderIssued    ? 'ok' : (notInfo.driveOrder ? 'error' : 'info'),
invoice:        attributes.invoiceSent         ? 'ok' : (notInfo.invoice ? 'error' : 'info'),
}

    ; __line = 35
    ; __append("<div>")
    ; 
if(attributes.tripID){

    ; __line = 37
    ; __append("<div class=\"group\">")
    ; 

    ; __line = 38
    ; __append("<div class=\"head\">")
    ; __append( storage.__('trips.schedulerSummary.title') )
    ; __append("</div>")
    ; 

    ; __line = 39
    ; __append("<div class=\"value\">")
    ; __append(escapeFn( attributes.title ))
    ; __append("</div>")
    ; 

    ; __line = 40
    ; __append("</div>")
    ; 

    ; __line = 41
    ; __append("<div class=\"group\">")
    ; 

    ; __line = 42
    ; __append("<div class=\"head\">")
    ; __append( storage.__('trips.schedulerSummary.internalNotices') )
    ; __append("</div>")
    ; 

    ; __line = 43
    ; __append("<div class=\"value\">")
    ; __append( String(attributes.internalNotices || '').replace(/\n+/g, '<br>') )
    ; __append("</div>")
    ; 

    ; __line = 44
    ; __append("</div>")
    ; 

    ; __line = 45
    ; __append("<div class=\"group\">")
    ; 

    ; __line = 46
    ; __append("<div class=\"head\">")
    ; __append( storage.__('trips.schedulerSummary.timeRange') )
    ; __append("</div>")
    ; 

    ; __line = 47
    ; __append("<div class=\"value\">")
    ; __append(escapeFn( timeRange ))
    ; __append("</div>")
    ; 

    ; __line = 48
    ; __append("</div>")
    ; 

    ; __line = 49
    ; __append("<div class=\"group\">")
    ; 

    ; __line = 50
    ; __append("<div class=\"head\">")
    ; __append( storage.__('trips.schedulerSummary.numberOfPersons') )
    ; __append("</div>")
    ; 

    ; __line = 51
    ; __append("<div class=\"value\">")
    ; __append(escapeFn( attributes.numberOfPersons ))
    ; __append("</div>")
    ; 

    ; __line = 52
    ; __append("</div>")
    ; 

    ; __line = 53
    ; __append("<div class=\"group\">")
    ; 

    ; __line = 54
    ; __append("<div class=\"head\">")
    ; __append( storage.__('trips.schedulerSummary.clientAddress') )
    ; __append("</div>")
    ; 

    ; __line = 55
    ; __append("<div class=\"value\">")
    ; __append( String(attributes.clientAddress || '').replace(/\n+/g, '<br>') )
    ; __append("</div>")
    ; 

    ; __line = 56
    ; __append("</div>")
    ; 

    ; __line = 57
    ; __append("<div class=\"group\">")
    ; 

    ; __line = 58
    ; __append("<div class=\"head\">")
    ; __append( storage.__('trips.schedulerSummary.status.head') )
    ; __append("</div>")
    ; 

    ; __line = 59
    ; __append("<div class=\"value flags\">")
    ; 
for(const [flag, severity] of Object.entries(flags)){

    ; __line = 61
    ; __append("<div class=\"flag\">")
    ; 

    ; __line = 62
    ; __append("<div class=\"severity_")
    ; __append( severity )
    ; __append("\"></div>")
    ; 

    ; __line = 63
    ; __append(escapeFn( storage.__(`trips.schedulerSummary.status.${flag}`) ))
    ; 

    ; __line = 64
    ; __append("</div>")
    ; 
}

    ; __line = 66
    ; __append("</div>")
    ; 

    ; __line = 67
    ; __append("</div>")
    ; 
}

    ; __line = 69
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/office/scheduler/tripSummary.ejs

}